<template>
  <section>
    <div class="home container">
      <img src="@/assets/p4wa.jpeg"
        width="466" height="312"
        alt="Postcards 4 Washington" class="centered"/>

      <h5>Join us to write postcards for amazing local
      Washington State progressive candidates
      in {{ new Date().getFullYear() }}!</h5>

      <p><b>Every {{ new Date().getFullYear() }} writer needs to
      officially sign up,</b> even if you’ve written with
      Postcards4WA in past years. Thank you for taking action
      in {{ new Date().getFullYear() }}!</p>

      <p style='text-align:center'>
        <a class="btn btn-primary"
          target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSd3qfzeYX2ZLOBaoxVNxABGH-D3brUH79B0o2aUYa4nLyDEXQ/viewform">
          Sign up to write postcards with us
        </a>
      </p>

      <p style='text-align:center'>
        <a class="btn btn-info" 
          target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdQL732CcGv-qLwnPkNi7QJWwf1i5_3sX-mn_h3KtR1O4lYqA/viewform">Request Addresses</a>
      </p>

      <p style='text-align:center'>
        <a class="btn btn-info"  style="background-color: #c6996f; border:none"
          target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSciAVYPLmfSR70wXb7ymWA-EvcurbUaRKQuce9tXSg1EsmV-A/viewform">Log Completed Cards</a>
      </p>

      <p>Over the past 6 years we've worked with 70 candidates and have
      sent about 182,000 postcards.
      With your help in {{ new Date().getFullYear() }}, we aim to
      have our best year yet!</p>

      <p>Sign up above to write with Postcards4WA in
      {{ new Date().getFullYear() }} and help WA keep our momentum
      moving forward. See the <a href="/faq">FAQ page</a> to learn more about how
      candidates are chosen as well as a few changes to be
      aware of this year. </p>

      <p>Each postcard we write increases the likelihood that
      we’ll elect great representation in November!</p>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {}
}
</script>
